import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import classes from "./main.module.css"
import MainPage from "./components/MainPage";
import PolicyTerms from "./components/PolicyTerms";
import AppPolicy from "./components/AppPolicy";
import Footer from "./components/Footer";

function AppLayout() {
  const location = useLocation();
  const hideFooter = location.pathname.startsWith('/app-policy/');

  return (
    <div className={classes.Body}>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/policy" element={<PolicyTerms />} />
        <Route path="/app-policy/:appName" element={<AppPolicy />} />
      </Routes>
      {!hideFooter && <Footer />}
    </div>
  );
}

function App() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-out-cubic',
      once: true,
      offset: 50,
    });
  }, []);

  return (
    <Router>
      <AppLayout />
    </Router>
  );

}

export default App